module.exports = __webpack_public_path__ + "themes/fq/img/button-normal.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/button-normal.png
// module id = 7
// module chunks = d-game